module.exports = __webpack_public_path__ + "img/visual-d-lg.5c3bf4ff.png";